/* TMALL SALE OFFER 2+3 CANDIDATE 2026-09-11 */
(() => {
  'use strict';

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `${(cents / 100).toFixed(2).replace('.', ',')} lei`;
  };

  const syncCard = (select) => {
    const card = select && select.closest('.product-card');
    const option = select && select.options && select.options[select.selectedIndex];
    if (!card || !option || !option.dataset.variantinfo) return;

    let info;
    try { info = JSON.parse(option.dataset.variantinfo); } catch (_) { return; }

    const price = Number(info.price_cents || 0);
    const compareAt = Number(info.compare_at_price_cents || 0);
    const onSale = compareAt > price && price >= 0;
    const badge = card.querySelector('.tmall-sale-badge');
    const badgeValue = card.querySelector('.tmall-sale-badge__value');
    const note = card.querySelector('[data-tmall-card-saving]');
    const noteValue = note && note.querySelector('[data-tmall-saving-value]');

    if (badge) badge.classList.toggle('hidden', !onSale);
    if (note) note.classList.toggle('hidden', !onSale);
    if (!onSale) return;

    const percentage = Math.round(((compareAt - price) * 100) / compareAt);
    if (badgeValue) badgeValue.textContent = `-${percentage}%`;
    if (noteValue) noteValue.textContent = formatMoney(compareAt - price);
  };

  const syncAllCards = () => {
    document.querySelectorAll('.product-card select[name="id"]').forEach(syncCard);
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest && event.target.closest('.product-card select[name="id"]');
    if (select) window.setTimeout(() => syncCard(select), 25);
  }, true);

  window.addEventListener('productcardVariants', () => window.setTimeout(syncAllCards, 25));
  document.addEventListener('DOMContentLoaded', syncAllCards);
})();
